import { render, staticRenderFns } from "./serviceEvaluation.vue?vue&type=template&id=69964c20&scoped=true&"
import script from "./serviceEvaluation.vue?vue&type=script&lang=js&"
export * from "./serviceEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./serviceEvaluation.vue?vue&type=style&index=0&id=69964c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69964c20",
  null
  
)

export default component.exports